import React from 'react';
import { green, red } from '../../theme/themePrimitives';
import { Handle, NodeProps, Position } from '@xyflow/react';
import { Paper, Typography } from '@mui/material';

const ConditionItemNode: React.FC<NodeProps> = ({ data }) => {
  return (
    <Paper
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        padding: '6px 10px',
        backgroundColor: data?.conditionType ? green[400] : red[300],
        borderRadius: '10px',
        color: 'white'
      }}
    >

      {/* Node Label */}
      <Typography variant="body2" fontWeight="bold">{data.label as string || 'EMPTY'}</Typography>

      {/* Input and Output Handles */}
      <Handle type="target" position={Position.Top} style={{ background: '#555' }} />
      <Handle type="source" position={Position.Bottom} style={{ background: '#555' }} />
    </Paper>
  );
};

export default ConditionItemNode;
